import React from 'react'
import { cn } from '@utils/safeTs'
import styles from './FlussoPersonalizzazionePosizioneConfigurazione.module.sass'
import { PersonalizzazioneOrdineType, PosizionePersonalizzazioneType } from '@utils/types'
import useTrans from '@hooks/useTrans'


interface Props {
  posizione: PosizionePersonalizzazioneType
  personalizzazione: PersonalizzazioneOrdineType
  className?: string
}

const FlussoPersonalizzazionePosizioneConfigurazione = (props: Props) => {

  const { 
    posizione,
    personalizzazione,
    className = '',
  } = props

  const t = useTrans()

  return (
    <div className={cn(styles.root, className)}>
      <p className={styles.title}>{t('Configurazione')}</p>
      <div className={styles.dataList}>
        <div className={styles.dataRow}>
          <span>{t("Tecnica")}:</span>
          <strong>{posizione.tecnica.nome}</strong>
        </div>
        <div className={styles.dataRow}>
          <span>{t("Colori")}:</span>
          <strong>{posizione.numeroColoriPosizione.fullColor ? posizione.numeroColoriPosizione.nome : t("{0} colori - {1}", [posizione.numeroColoriPosizione.numeroColori, posizione.pantoni?.map(p => p.pantone).join(", ")])}</strong>
        </div>
        <div className={styles.dataRow}>
          <span>{t("Dimensioni")}:</span>
          <strong>{t("{0} x {1} cm", [posizione.larghezza, posizione.altezza])}</strong>
        </div>
        <div className={styles.dataRow}>
          <span>{t("Confezionamento")}:</span>
          <strong>
            {t(personalizzazione.confezionamentoRichiesto ? "Sì" : "No")}
            {personalizzazione?.confezionamento?.nome ? <>{' '}-{' '}{personalizzazione.confezionamento.nome}</> : <></>}
          </strong>
        </div>
      </div>
    </div>
  )
}

export default FlussoPersonalizzazionePosizioneConfigurazione
